'use client'
import Image from 'next/image'
import LinkComponent from '@components/LinkComponent'
import { sendGAEvent } from '@next/third-parties/google'

const ProjectInfoCard = ({ project, dictionary }) => {
  return (
    <LinkComponent 
      href={`/${project?.newDevelopment ? 'new-developments' : 'projects'}/${project.slug}`} 
      className='w-full rounded-md mt-2'
      onClick={() => sendGAEvent({ 
          event: "select_project",
          pproject_id: project.id,
          project_name: project.name,
          project_type: project.newDevelopment ? 'new_development' : 'project'
      })} 
    >
         <div className='relative w-full aspect-[4/3] rounded-md overflow-hidden hover:shadow-md  duration-150'>
            <Image
                // placeholder="blur"
                // blurDataURL={property.blur}
                // className='object-fit'
                className='object-cover cursor-pointer'
                src={project.cover !== undefined ? project.cover : '/images/test.jpg'}
                // width={imageWidth}
                // height={imageHeight}
                fill={true}
                alt={`Image of ${project.name}`}
            />
            <div className='absolute left-0 bottom-0 right-0 p-2 bg-maincolor bg-opacity-70'>
                <h3 className='text-light text-xl font-semibold'>{project.name}</h3>
                <p className='text-light'>{project.newDevelopment ? dictionary.newDevelopment : dictionary.project}</p>
            </div>
        </div>
    </LinkComponent>
  )
}

export default ProjectInfoCard